<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Top Navigation Bar (認証画面以外) -->
    <TopNavigationBar v-if="!isGuestRoute" />

    <!-- Side Menu (認証画面以外) -->
    <AppNavigation v-if="!isGuestRoute" />

    <!-- Main Content -->
    <main
      :class="[
        // 認証画面以外: Top Navigation Bar分のpadding
        !isGuestRoute ? 'pt-16' : '',
        // 認証画面以外: デスクトップでSide Menu分のマージン
        !isGuestRoute ? 'lg:ml-64 ml-0' : '',
        !isGuestRoute ? 'p-6' : '',
        'min-h-screen'
      ]"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import TopNavigationBar from '@/components/TopNavigationBar.vue'
import AppNavigation from '@/components/AppNavigation.vue'

const route = useRoute()

// 認証画面またはパブリックページかどうかを判定
const isGuestRoute = computed(() => {
  // 認証画面（ログイン、OTP検証）
  if (route.meta.guest === true) return true

  // APIドキュメント等のパブリックページ
  if (route.path.startsWith('/docs/')) return true

  return false
})
</script>

<style>
/* グローバルスタイル */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
